<template>
	<div class="record">
		<div class="container">
			<div class="title">留言记录</div>
			<div style="height:120px;">
				<div style="float:right">
					<el-form :inline="true">
						<el-form-item label="用户名">
							<el-input placeholder="用户名" v-model="lavingRecordsRequest.consultName"></el-input>
						</el-form-item>
						<el-form-item label="关键词">
							<el-input placeholder="关键词" v-model="lavingRecordsRequest.keyword"></el-input>
						</el-form-item>
						<el-form-item label="处理状态">
							<el-select placeholder="请选择" v-model="lavingRecordsRequest.state">
								<el-option
									v-for="item in option2"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="渠道">
							<el-select v-model="lavingRecordsRequest.ChannelId">
								<el-option :key="-1" :value="-1" label="全部渠道"></el-option>
								<el-option
									v-for="item in channelEnumList"
									:key="item.id"
									:value="item.id"
									:label="item.name"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="联络原因">
							<!-- <el-select v-model="lavingRecordsRequest.ConsultationTypeId">
								<el-option :key="-1" :value="-1" label="全部分类"></el-option>
								<el-option
									v-for="item in consultationTypes"
									:key="item.id"
									:value="item.id"
									:label="item.typeName"
								></el-option>
							</el-select> -->
							<div style="margin-top:5px">
								<consultationTypeTree
									:currentNodeKey="currentNodeKey"
									@onSelectedId='onSelectedId'
								/>
							</div>
						</el-form-item>
						<el-form-item label="产品分类">
							<div style="margin-top:5px">
								
								<productTree :currentNodeKey="currentNodeKeyProduct" @onSelectedId="onProductTreeSelectedId" />
							</div>
						</el-form-item>
						<el-form-item label="联系规格" prop="contactSpecificationsId">
							<el-select v-model="lavingRecordsRequest.contactSpecificationsId"  placeholder="请选择">
								<el-option
								:key="0"
								label="全部"
								:value="0">
								</el-option>
								<el-option
								v-for="item in contactSpecificationsList"
								:key="item.id"
								:label="item.name"
								:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="危机程度" prop="crisisId">
							<el-select v-model="lavingRecordsRequest.crisisId"  placeholder="请选择">
								<el-option :key="0" label="全部" :value="0"></el-option>
								<el-option
								v-for="item in crisisList"
								:key="item.id"
								:label="item.crisisName"
								:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					<el-form-item label="日期">
							<el-date-picker
								v-model="pickerValue"
								type="datetimerange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-ddTHH:mm:ss"
							></el-date-picker>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="getLeavingRecords('留言记录-搜索')">搜索</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div style="clear: both;"></div>
				<div style="float:right">
					<!-- <el-button type="primary" @click="getLeavingRecords">搜索</el-button> -->
					<!-- <el-button>导出</el-button> -->
				</div>
			</div>

			<div class="table_box">
				<div class="total">
					共
					<span>{{lavingRecordsRequest.pagination.total}}</span> 条
				</div>
				<el-table
					ref="multipleTable"
					:data="tableData"
					tooltip-effect="dark"
					style="width: 100%;"
					border
					stripe
					v-loading="loading"
					@row-click="rowClick"
				>
					<el-table-column prop="consultName" label="用户名" width="120"></el-table-column>
					<el-table-column prop="messageContent" label="留言内容" width="400" show-overflow-tooltip></el-table-column>
					<el-table-column prop="createTime" label="留言时间" width="200"></el-table-column>
					<el-table-column prop="channelName" label="渠道" width="150"></el-table-column>
					<el-table-column prop="typeName" label="联络原因" width="100">
					    <template slot-scope="scope">
							 <el-tooltip class="item" effect="dark" :content="scope.row.typeNameTree" placement="top-start">
								 <div> {{scope.row.typeName}}</div>
							</el-tooltip>
						</template>
					</el-table-column>
							<el-table-column prop="productName" label="产品名称" width="100">
					    <template slot-scope="scope">
							 <el-tooltip class="item" effect="dark" :content="scope.row.productNameTree" placement="top-start">
								 <div> {{scope.row.productName}}</div>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column prop="contactSpecificationsName" label="联系规格"></el-table-column>
					<el-table-column prop="crisisName" label="危机程度"></el-table-column>
					<el-table-column label="当前状态" width="120">
						<template slot-scope="scope">
							<span>
								<a href="#" :class="scope.row.processingState==1?'badgeSuccess':'badgeRed'">●</a>
								{{scope.row.stateName}}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="completionTime" label="处理时间">
						<template slot-scope="scope">{{formatTime(scope.row.completionTime)}}</template>
					</el-table-column>
					<el-table-column prop="kfNickName" label="跟进人"></el-table-column>
				</el-table>
			</div>
			<div class="pagination">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[10, 20, 30, 50]"
					:page-size="lavingRecordsRequest.pagination.pageSize"
					layout="sizes, prev, pager, next"
					:total="lavingRecordsRequest.pagination.total"
				></el-pagination>
			</div>
		</div>
		<div class="aside" v-if="show1" v-loading="userInfoLoading">
			<div class="reply">
				<div class="flex-title">
					快捷回复
					<el-button
						@click="tagProcessed"
						:disabled="processingState==1"
					>{{processingState==1?"已处理":"设置为已处理"}}</el-button>
				</div>
				<div class="talk">
					<div class="container" id="testDiv">
						<p v-if="chatBoxLoading">{{loadingText}}</p>
						<div
							:key="index"
							:class="item.dialogues[0].sender==2?'talk_right':'talk_left'"
							v-for="(item,index) in dialogues"
						>
							<div class="content" v-if="item.dialogues[0].sender===2">
								<div class="text">
									<span :key="index" v-for="(items,index) in item.dialogues">
										<img v-if="items.messageType==2" :src="items.content" />
										<video v-else-if="items.messageType==3" :src="items.content"></video>
										<span v-else>{{items.content}}</span>
									</span>
								</div>
								<div class="creatime">{{formatTime(item.sendTime)}}</div>
							</div>
							<div class="heading" v-if="item.dialogues[0].sender==2">
								<img :src="defaultKfHeadimg" />
							</div>
							<div class="heading" v-if="item.dialogues[0].sender==1">
								<img :src="consultHeadImg" />
							</div>
							<div class="content" v-if="item.dialogues[0].sender==1">
								<div class="text">
									<span :key="index" v-for="(items,index)  in item.dialogues">
										<img v-if="items.messageType==2" :src="items.content" />
										<video 
											v-else-if="items.messageType==3" 
											width="150px" 
											:src="items.content"
											autoplay 
											muted
											controls 
										></video>
										<span v-else>{{items.content}}</span>
									 
									</span>
								</div>
								<div class="creatime">{{formatTime(item.sendTime)}}</div>
							</div>
						</div>
						<!-- <div class="talk_right">
							<div class="content">
								<div class="text">以上为历史消息记录以上为历史消息记录</div>
							</div>
							<div class="heading">
								<img src="../../../assets/heading.png" />
							</div>
						</div>-->
					</div>
				</div>
				<textarea
					id="charInput"
					v-model="replyMessage"
					class="charInput"
					placeholder="请输入文字按回车(Enter)键发送"
					@keyup.enter="sendMessage"
				></textarea>
			</div>
			<!-- :currentUserInfo="currentUserInfo" -->
			<!-- :consultationTypes="consultationTypes" -->
			<userinfo
				:addressList="addressList"
				:channelName="channelName"
				:accessChatId="selectedAccessId"
				:openid="selectedOpenid"
				:rowKey="rowKey"
				auditChannel="留言记录—获取用户信息"
				@updUserInfo="updUserInfo"
				@onLoading="onLoading"
				@saveCustomerCenter="saveCustomerCenter"
			/>
			<a class="close" @click="close">x</a>
		</div>
	</div>
</template>
<script>
import userinfo from '../talks/userInfo'
import { DateTime } from '@/utils/common'
import { FormatTimes } from '@/utils/FormatTime'
import { Base64 } from 'js-base64'
import consultationTypeTree  from '../talks/consultationTypeTree.vue'
import  productTree from '../talks/productTree.vue'
export default {
	name: 'lyrecord',
	props: [],
	data() {
		return {
			show1: false,
			input1: '',
			pickerValue: [],
			option1: [
				{
					value: '选项1',
					label: '全部未留言32424',
				},
			],
			option2: [
				{
					value: -1,
					label: '全部留言',
				},
				{
					value: 1,
					label: '已处理',
				},
				{
					value: 2,
					label: '未处理',
				},
			],
			tableData: [],
			lavingRecordsRequest: {
				consultName: '',
				state: -1,
				keyword: '',
				startTime: null,
				endTime: null,
				ChannelId: -1,
				ConsultationTypeId: -1,
				crisisId:0,
				contactSpecificationsId:0,
				pagination: {
					pageIndex: 1,
					pageSize: 20,
					total: 0,
				},
			},
			pickerOptions: {
				shortcuts: [
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 7
							)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 30
							)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 90
							)
							picker.$emit('pick', [start, end])
						},
					},
				],
			},
			loading: false,
			addressList: [],
			currentUserInfo: {}, //当前用户信息
			userInfoLoading: false,
			dialoguepagination: {
				pageIndex: 1,
				pageSize: 10,
				total: 0,
			},
			dialogues: [],
			selectedOpenid: '',
			selectedAccessId: 0,
			selectedMessageId: 0,
			chatBoxLoading: false,
			loadingText: '',
			replyMessage: '',
			defaultKfHeadimg: '',
			consultHeadImg: '',
			channelName: '',
			processingState: 0,
			// consultationTypes: [],// 内部自己调用所以不用传了
			channelEnumList: [],
			leavingObj: {
				keyWord: '',
			},
			rowKey:0,
			currentNodeKey:[],
			contactSpecificationsList:[],
			crisisList:[],
			currentNodeKeyProduct:[]
		 
		}
	},
	watch: {
		dialogues: function () {
			setTimeout(function () {
				var ele = document.getElementById('testDiv')
				ele.scrollTop = ele.scrollHeight
			}, 50)
		},
	},
	mounted: function () {},
	created: function () {
		this.defaultKfHeadimg = localStorage.getItem('defaultKfHeadimg');
		this.getLeavingRecords('留言记录-初始化');
		this.getAddress();
		this.getConsultationTypes();
		this.getMiniChannelEnum();
		this.getContactSpecifications();
		this.getCrisisEnum();
		let $this = this
	},
	components: {
		userinfo,
		consultationTypeTree,
		productTree
	},
	methods: {
		/**
		 * 格式化日期
		 */
		formatTime(time) {
			let date = new DateTime()
			if (time == null) return '--'
			return FormatTimes(time, 'yyyy-MM-dd hh:mm:ss')
		},
		/**
		 * 获取留言记录
		 */
		getLeavingRecords(auditChannel) {
			let vm = this
			vm.loading = true
			if (vm.pickerValue != null && vm.pickerValue.length > 0) {
				vm.lavingRecordsRequest.startTime = vm.pickerValue[0]
				vm.lavingRecordsRequest.endTime = vm.pickerValue[1]
			} else {
				vm.lavingRecordsRequest.startTime = null
				vm.lavingRecordsRequest.endTime = null
			}
			this.axios
				.post('CustomerMessage/GetLR', vm.lavingRecordsRequest,{Headers:{auditChannel: Base64.encode(auditChannel)}})
				.then(function ({ data }) {
					if (data.result) {
						vm.tableData = data.data.list
						vm.lavingRecordsRequest.pagination =
							data.data.pagination
					} else {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					}
					vm.loading = false
				})
		},
		getConsultationTypes() {
			let vm = this
			this.axios
				.get('ConsultationTypes/getConsultTypes')
				.then(function ({ data }) {
					if (data.result) {
						vm.consultationTypes = data.data
					}
				})
		},
		handleChange(value) {},
		close() {
			this.show1 = false
		},
		handleSizeChange(val) {
			this.lavingRecordsRequest.pagination.pageSize = val
			this.getLeavingRecords('留言记录-更换条数')
		},
		handleCurrentChange(val) {
			this.lavingRecordsRequest.pagination.pageIndex = val
			this.getLeavingRecords('留言记录-翻页')
		},
		selectedTime(val) {
			let vm = this
			if (val != null) {
				vm.lavingRecordsRequest.startTime = val[0]
				vm.lavingRecordsRequest.endTime = val[1]
			} else {
				vm.lavingRecordsRequest.startTime = null
				vm.lavingRecordsRequest.endTime = null
			}
			vm.getLeavingRecords('留言记录-查询')
		},
		rowClick(val) {
			console.debug(val)
			let vm = this
			vm.show1 = true
			vm.selectedAccessId = val.accessChatId
			vm.selectedOpenid = val.miniOpenId
			vm.selectedMessageId = val.id
			vm.consultHeadImg = val.consultHeadImg
			vm.channelName = val.channelName
			vm.getUserInfo(val.miniOpenId, val.accessChatId)
			const rowKey = vm.rowKey;
			vm.rowKey=rowKey+1;
			vm.processingState = val.processingState
			vm.getDialogue()
		},
		getAddress() {
			let vm = this
			this.axios.get('Address/GetAdd').then(function ({ data }) {
				if (data.result) {
					vm.addressList = data.data
				}
			})
		},
		getUserInfo(openid, accessChatId) {
			let vm = this
			if (openid == '' || accessChatId == 0) {
				return
			}
			vm.userInfoLoading = true
			this.axios
				.get('ConsultantInfo/getUserInfo', {
					params: { openid: openid, accessChatId: accessChatId },
				})
				.then(function ({ data }) {
					if (data.result) {
						vm.currentUserInfo = data.data
					} else {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					}
					vm.userInfoLoading = false
				})
		},
		handleScroll() {
			let vm = this
			var testDiv = document.getElementById('testDiv')
			var scrollTop = testDiv.scrollTop
			if (scrollTop == 0) {
				vm.dialoguepagination.pageIndex =
					vm.dialoguepagination.pageIndex + 1
				if (
					vm.dialoguepagination.pageIndex <
						vm.dialoguepagination.total /
							vm.dialoguepagination.pageSize &&
					vm.chatBoxLoading == false
				) {
					vm.chatBoxLoading = true
					vm.loadingText = '加载中...'
					vm.getDialogue()
				} else {
					vm.loadingText = '已经是最顶部了...'
				}
			} else {
				this.loading = false
			}
		},
		getDialogue() {
			let vm = this
			var obj = new Object()
			obj.accessChatId = vm.selectedAccessId
			obj.pagination = vm.dialoguepagination
			this.axios
				.post('Dialogue/getLeaving', obj,{Headers:{AuditChannel: Base64.encode("留言记录-获取对话")}})
				.then(function ({ data }) {
					if (data.result) {
						vm.dialogues = data.data.list
						vm.dialoguepagination = data.data.pagination
					}
					vm.chatBoxLoading = false
				})
		},
		sendMessage() {
			let date = new DateTime()
			let str = date.Now()
			let vm = this
			let send = new Object()
			var array = []
			var obj = new Object()
			obj.consultId = vm.selectedOpenid
			obj.sender = 2
			obj.content = vm.replyMessage.replace('\n', '')
			obj.messageType = 1
			obj.accessChatId = vm.selectedAccessId
			array.push(obj)
			send.Receiver = vm.selectedOpenid
			send.dialogues = array
			send.sendTime = str
			vm.replyMessage = ''
			vm.dialogues.push(send)
			let sendobj = { ...send }
			vm.$delete(sendobj, 'sendTime')
			this.axios
				.post('SendMessage/ReplyMessage', sendobj,{Headers:{AuditChannel: Base64.encode("留言记录-发送消息")}})
				.then(function ({ data }) {})
		},
		tagProcessed() {
			let vm = this
			this.axios
				.get('CustomerMessage/UpdLavState', {
					params: {
						customerMessageId: vm.selectedMessageId,
						state: 1, //1 已处理 2 未处理
					},
					Headers:{auditChannel:Base64.encode("留言记录-处理状态")}
				})
				.then(function ({ data }) {
					if (data.result) {
						vm.getLeavingRecords('留言记录-刷新页面')
						vm.show1 = false
						vm.$message({
							message: '标记成功',
							type: 'success',
						})
					} else {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					}
				})
		},
		updUserInfo(val) {
			let vm = this
			this.axios
				.post('ConsultantInfo/updUserInfo', val,{Headers:{auditChannel:Base64.encode("留言记录-更新用户信息")}})
				.then(function ({ data }) {
					if (!data.result) {
				 
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					}
				})
		},
		saveCustomerCenter(val) {
			let vm = this
			val.accessChatId = vm.selectedAccessId
			this.axios
				.post('AccessChat_Subtotal', val)
				.then(function ({ data }) {
					if (!data.result) {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					} else {
						vm.getLeavingRecords('留言记录-刷新页面');
						vm.$message({ type: 'success', message: '保存成功' })
					}
				})
		},
		onLoading(val) {
			this.userInfoLoading = val
		},
		getMiniChannelEnum() {
			let vm = this
			this.axios
				.get('MiniChannelEnum/SelectList')
				.then(function ({ data }) {
					vm.channelEnumList = data
				})
		},
		getConsultationTypes() {
			let vm = this
			this.axios
				.get('ConsultationTypes/getConsultTypes')
				.then(function ({ data }) {
					if (data.result) {
						vm.consultationTypes = data.data
					}
				})
		},
		onSelectedId(val){
			this.currentNodeKey=val;
			if(val.length==0){
				this.lavingRecordsRequest.ConsultationTypeId=-1;
			}else{
				this.lavingRecordsRequest.ConsultationTypeId=val[0];
			}
	
		},
		getContactSpecifications(){
			let vm =this;
			
			this.axios.get('/ContactSpecifications').then(function({data}){
				vm.contactSpecificationsList=data.data
			})
		},
		getCrisisEnum(){

			let vm =this;
			
			this.axios.get('/CrisisEnum').then(function({data}){
				vm.crisisList=data.data
			})
		},
		onProductTreeSelectedId(val){
			this.currentNodeKeyProduct=val;
			if(val.length==0){
				this.lavingRecordsRequest.productId=-1;
			}else{
				this.lavingRecordsRequest.productId=val[0];
			}
	
		} 
	},
}
</script>

<style scoped>
.badgeRed {
	width: 16px;
	height: 16px;
	display: inline-block;
	font-size: 20px;
	line-heigth: 16px;
	text-align: center;
	color: #f00;
	text-decoration: none;
}
.badgeSuccess {
	width: 15px;
	height: 15px;
	display: inline-block;
	font-size: 20px;
	line-heigth: 16px;
	text-align: center;
	color: #52c41a;
	text-decoration: none;
}
.close {
	display: block;
	position: absolute;
	width: 30px;
	height: 30px;
	line-height: 28px;
	text-align: center;
	background-color: #fff;
	left: -30px;
	top: 20px;
	font-size: 16px;
	color: #999;
	box-shadow: -2px -1px 2px 1px rgba(0, 0, 0, 0.1);
}
.record {
	height: 100%;
	overflow: auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	position: relative;
	width: 100%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	position: relative;
}
.container {
	padding: 0px 45px;
	height: 100%;
}
.title {
	font-size: 16px;
	font-weight: bold;
	padding: 30px 0 10px 0;
}
.search-box {
	height: 120px;

	padding-bottom: 20px;
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.search-box .el-input-group {
	width: 320px;
	float: left;
}
.float {
	float: right;
}
.total {
	border: 1px solid #eee;
	padding: 12px;
	border-bottom: none;
}
.total span {
	color: #409eff;
}
.pagination {
	text-align: right;
}
.el-pagination {
	text-align: right;
	margin-top: 50px;
	display: inline-block;
}
/*侧边弹窗*/
.aside {
	position: fixed;
	top: 62px;
	right: 0;
	height: 100%;
	width: 740px;
	background-color: #fff;
	z-index: 300;
	box-shadow: -4px -1px 4px 1px rgba(0, 0, 0, 0.1);
}
/*留言详情*/
.reply {
	width: 50%;
	display: inline-block;
	float: left;
	border-right: 1px solid #ddd;
	box-sizing: border-box;
	height: 100%;
}
.flex-title {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 42px;
	line-height: 42px;
	border-bottom: 1px solid #ddd;
	padding: 0 15px;
}
.talk {
	padding: 30px 0px 10px 0;
	height: 60%;
	border-bottom: 1px solid #ddd;
	overflow-y: auto;
	overflow-x: hidden;
}
.search-box {
	/* line-height: 44px; */
	/* border-bottom: 1px solid #ddd; */
}
.search-box .el-input-group {
	width: 320px;
}
.talk p {
	text-align: center;
	color: #bbb;
	line-height: 30px;
}
.container {
	overflow-x: hidden;
	overflow-y: auto;
}
.charInput {
	display: block;
	width: 300px;
	padding: 5px 15px;
	min-height: 120px;
	max-height: 120px;
	outline: none;
	font-size: 14px;
	line-height: 30px;
	word-wrap: break-word;
	margin: 30px auto 0;
	background-color: #f1f1f1;
	border: 1px solid #ddd;
	resize: none;
}
.creatime {
	color: #999;
	padding: 5px 10px 5px 50px;
	margin-bottom: 10px;
}
/*滚动条样式*/
::-webkit-scrollbar {
	width: 14px;
}

::-webkit-scrollbar-track {
	border-radius: 5px;
}

::-webkit-scrollbar-thumb {
	background-color: #d6d6d6;
	border-radius: 5px;
}

.talk_left {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	margin-bottom: 10px;
	min-width: 100px;
}
.talk_left .content {
	margin-left: 10px;
}
.talk_left .content img {
	max-width: 195px;
}
.text {
	max-width: 195px;
	padding: 15px;
	background-color: #dcedf9;
	border-radius: 5px;
	font-size: 14px;
	letter-spacing: 1px;
	word-wrap: break-word;
}
.talk_left .text::after {
	position: absolute;
}
.talk_right {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	margin-bottom: 10px;
}
.talk_right .content {
	margin-right: 10px;
}
.talk_right .content img {
	max-width: 225px;
}
.heading {
	width: 40px;
	height: 40px;
	border-radius: 50%;
}
.heading img {
	width: 100%;
	height: 100%;
	border-radius: 50%;
}
/*用户信息*/

.message {
	padding: 0px 0 30px 30px;
	box-sizing: border-box;
}
.access {
	margin-top: 20px;
}
.option {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.lablelist span {
	display: inline-block;
	margin: 15px 15px 5px 0;
	color: #666;
	min-width: 60px;
}
.lablelist span.special {
	vertical-align: top;
}
.iconfont {
	cursor: pointer;
}
.access textarea {
	resize: none;
	width: 100%;
	height: 50px;
	padding: 5px;
	line-height: 20px;
	outline: none;
}
.remark {
	resize: none;
	margin-top: 10px;
}
.save {
	float: right;
	margin: 10px 20px;
}

.f-right {
	float: right;
	cursor: pointer;
}
.el-select {
	float: right;
	width: 140px;
	margin-left: 15px;
}
.float .el-input__inner {
	font-size: 12px;
}
.el-input__icon {
	line-height: 28px;
}
</style>
<style>
</style>
<style>
.record .aside .userinfor {
	width: 50%;
	display: inline-block;
	float: right;
}
.record .message {
	box-sizing: border-box;
	height: 100%;
	overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/lyrecords/messageRecord.vue